var Globals = /** @class */ (function () {
    function Globals() {
    }
    Object.defineProperty(Globals, "root", {
        /**
         * The top level container hosting the app. Usually the html document, but can be a shadow root if hosted in another site.
         * Use this for adding top level events.
         */
        get: function () {
            var _a;
            return (_a = this.shadowRoot) !== null && _a !== void 0 ? _a : window.document;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Globals, "rootElement", {
        /**
         * The top level element hosting the app. Usually html document.body, but can be a shadow root if hosted in another site.
         * Use this for adding elements to the root level.
         */
        get: function () {
            var _a;
            return (_a = this.shadowRoot) !== null && _a !== void 0 ? _a : window.document.body;
        },
        enumerable: false,
        configurable: true
    });
    return Globals;
}());
export default Globals;
